export const initShowText = () => {
    document.querySelectorAll('.show-more-less').forEach(buttonGroup => {
        const readMoreBtn = buttonGroup.querySelector('.read-more');
        const readLessBtn = buttonGroup.querySelector('.read-less');
        const hiddenContent = buttonGroup.closest('.cell').querySelector('.hidden-content');


        if (readMoreBtn && readLessBtn && hiddenContent) {
            readMoreBtn.addEventListener('click', () => {
                console.log('clicked')
                hiddenContent.classList.add('not-hidden');
                readMoreBtn.style.display = 'none';
                readLessBtn.style.display = 'flex';
            });

            readLessBtn.addEventListener('click', () => {
                hiddenContent.classList.remove('not-hidden');
                readMoreBtn.style.display = 'flex';
                readLessBtn.style.display = 'none';
            });
        }
    });
};
